/* eslint-disable import/prefer-default-export */
import { FormTemplate } from 'data/template/template.types';

export const securityInfoTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Security Info',
  key: 'SECINFO',
  main: {
    metadata: {
      layout: {
        rows: [
          [
            'id',
          ],
          ['catype', 'keyalgorithm'],
          ['litype', 'aftype', 'commonName'],
          [
            'name',
            'description',
            'intfType',
          ],
          [
            'nameHint',
            '$empty',
            '$empty',
          ],
          [
            'tlsVersion',
            'tlsType',
            'authenType',
          ],
          [
            'depth',
            'hostname',
            'cipherFile',
          ],
          [
            'privateKey',
            '$empty',
            '$empty',
          ],
          [
            'privateKeyFile',
            'passphrase',
            '$empty',
          ],
          [
            'certificate',
            '$empty',
            '$empty',
          ],
          [
            'certificateFile',
            'certificateAuthority',
            'certificateDirectory',
          ],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      catype: {
        label: 'Cert Type',
        type: 'select',
        initial: 'self',
        options: [
          {
            label: 'Self-Signed',
            value: 'SELFSIGNED',
          },
          {
            label: 'XCCA',
            value: 'XCCA',
          }
        ],
      },
      name: {
        label: 'Security Information ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 16,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      description: {
        label: 'Description',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 256,
            },
          ],
        },
      },
      intfType: {
        label: 'Interface Type',
        type: 'select',
        initial: 'HTTPS',
        options: [
          {
            label: 'HTTPS',
            value: 'HTTPS',
          },
          {
            label: 'FTPS',
            value: 'FTPS',
          },
          {
            label: 'TLS',
            value: 'TLS',
          },
          {
            label: 'DTLS',
            value: 'DTLS',
          },
        ],
      },
      nameHint: {
        type: 'custom',
        placeholder: 'Max 16 characters with no spaces',
        customComponent: 'nameHint',
        className: 'field-desc',
      },
      tlsVersion: {
        label: 'TLS Version',
        type: 'select',
        initial: 'TLSv1.2',
        options: [
          {
            label: 'SSLv3',
            value: 'SSLv3',
          },
          {
            label: 'TLSv1',
            value: 'TLSv1',
          },
          {
            label: 'TLSv1.1',
            value: 'TLSv1.1',
          },
          {
            label: 'TLSv1.2',
            value: 'TLSv1.2',
          },
          {
            label: 'TLSv1.3',
            value: 'TLSv1.3',
          },
        ],
      },
      tlsType: {
        label: 'TLS',
        type: 'radio',
        inline: true,
        initial: 'Server',
        options: [
          {
            label: 'Client',
            value: 'Client',
          },
          {
            label: 'Server',
            value: 'Server',
          },
        ],
      },
      authenType: {
        label: 'Authentication',
        type: 'radio',
        inline: true,
        initial: 'MUTUAL',
        options: [
          {
            label: 'Simple',
            value: 'SIMPLE',
          },
          {
            label: 'Mutual',
            value: 'MUTUAL',
          },
        ],
      },
      depth: {
        label: 'Depth',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      hostname: {
        label: 'Host Name',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 164,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      cipherFile: {
        label: 'Cipher File',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 32,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      privateKey: {
        type: 'custom',
        initial: 'Private Key',
        customComponent: 'privateKey',
        className: 'section-label',
      },
      privateKeyFile: {
        label: 'File Name',
        type: 'text',
        initial: 'server.key',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 32,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      passphrase: {
        label: 'File Password',
        type: 'password',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 48,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      certificate: {
        type: 'custom',
        initial: 'Certificate',
        customComponent: 'certificate',
        className: 'section-label',
      },
      certificateFile: {
        label: 'File Name',
        type: 'text',
        initial: 'server.crt',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 32,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      certificateAuthority: {
        label: 'Authority Name',
        type: 'text',
        initial: 'root_cacert.perm.cert',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 32,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      certificateDirectory: {
        label: 'Directory',
        type: 'text',
        initial: '/usr/share/ssl/certs',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 128,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      aftype: {
        type: 'select',
        label: 'Access Function Type',
        initial: '',
        hide: 'true',
        options: [
          {
            label: 'Select an AF Type',
            value: '',
          }
        ],
        validation: {
          required: true
        }
      },
      litype: {
        type: 'select',
        label: 'LI Type',
        initial: '',
        hide: 'true',
        options: [
          {
            label: 'Select an LI Type',
            value: '',
          },
          {
            label: 'INI1',
            value: 'INI1',
          },
          {
            label: 'INI2',
            value: 'INI2',
          },
          {
            label: 'INI3',
            value: 'INI3',
          }
        ],
        validation: {
          required: true
        }
      },
      commonName: {
        type: 'text',
        label: 'Common Name',
        initial: '',
        hide: 'true',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 64,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        }
      },
      keyalgorithm: {
        type: 'select',
        label: 'Key Algorithm',
        initial: 'RSA_2048',
        hide: 'true',
        options: [
          {
            label: 'RSA 2048',
            value: 'RSA_2048',
          },
          {
            label: 'RSA 4096',
            value: 'RSA_4096',
          },
          {
            label: 'RSA 8192',
            value: 'RSA_8192',
          },
          {
            label: 'ECDSA 256',
            value: 'ECDSA_256',
          },
          {
            label: 'ECDSA 384',
            value: 'ECDSA_384',
          },
          {
            label: 'ECDSA 521',
            value: 'ECDSA_521',
          }
        ]
      }
    },
  },
};
